import { render, staticRenderFns } from "./U8interfacemangement.vue?vue&type=template&id=7b1e90b0&scoped=true&"
import script from "./U8interfacemangement.vue?vue&type=script&lang=js&"
export * from "./U8interfacemangement.vue?vue&type=script&lang=js&"
import style0 from "./U8interfacemangement.vue?vue&type=style&index=0&id=7b1e90b0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b1e90b0",
  null
  
)

export default component.exports